import CurrentManagementReportAnchor from "components/company/v2/CurrentManagementReportAnchor";
import useBrazilianIssuer from "components/company/v3/context/hooks/useBrazilianIssuer";
import SadFaceIcon from "components/icons/SadFaceIcon";
import FinancialHighlightsContent from "components/portfolio/components/FinancialHighlightsContent";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "components/ui/Select";
import type { IFinancialHighlightsQuery } from "lib/queries/__generated__/FinancialHighlightsQuery.generated";
import { FormattedMessage } from "react-intl";

interface BrazilianHighlightsContentProps {
  highlights?: IFinancialHighlightsQuery;
  setFilterByFinancialHighlightsId: (value: string | null) => void;
}

export default function BrazilianHighlightsContent({
  highlights,
  setFilterByFinancialHighlightsId,
}: BrazilianHighlightsContentProps) {
  const issuer = useBrazilianIssuer();

  if (!highlights || !highlights.financialHighlights) {
    return (
      <div className="flex h-full w-full items-center justify-center p-4 font-aeonik">
        <div className="space-y-2 text-center text-base tracking-wide text-gray-600">
          <div>
            <SadFaceIcon />
          </div>

          <FormattedMessage defaultMessage="Nenhum dado foi encontrado." id="i1Elih" />
        </div>
      </div>
    );
  }

  const candidateHighlights =
    highlights.financialHighlights.availableHighlights.length > 0
      ? highlights.financialHighlights.availableHighlights[0]._id
      : undefined;

  return (
    <div className="space-y-4">
      <div className="flex space-x-2">
        <Select
          onValueChange={(value) => setFilterByFinancialHighlightsId(value ?? null)}
          defaultValue={candidateHighlights}
        >
          <SelectTrigger className="w-full rounded-xl border-slate-200 bg-white font-aeonik tracking-wider sm:w-32">
            <SelectValue placeholder="Escolha o Trimestre" />
          </SelectTrigger>
          <SelectContent className="rounded-lg border border-slate-200 text-sm">
            {highlights.financialHighlights.availableHighlights.map((highlights) => (
              <SelectItem
                key={`selectBoxYear/${highlights._id}`}
                className="cursor-pointer rounded-lg text-sm"
                value={highlights._id}
              >
                {highlights.description}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <div className="grid auto-cols-max grid-flow-col gap-x-1 text-sm">
          <CurrentManagementReportAnchor
            lastQuarterlyManagementReport={issuer.lastQuarterlyManagementReport}
            lastYearlyManagementReport={issuer.lastYearlyManagementReport}
            reportSource={highlights.financialHighlights.reportSource}
            className="flex h-10 items-center justify-center rounded-lg bg-blue-50 px-3 font-medium text-blue-700 no-underline hover:underline"
          />
        </div>
      </div>

      <div className="text-base tracking-wider text-gray-700">
        <FinancialHighlightsContent
          key={highlights.financialHighlights.financialHighlights._id}
          content={highlights.financialHighlights.financialHighlights.highlights}
        />
      </div>
    </div>
  );
}
